// <<<<<<<<<<<<<<<<<<<<<<****************>>>>>>>>>>>>>>>>
export let developmentMode = false
// <<<<<<<<<<<<<<<<<<<<<<****************>>>>>>>>>>>>>>>>

export const WaitlistAPIResponseKeys = {
  success: 'success',
  already_on_waitlist: 'alreadyOnWaitlist',
  bad_image_encoding: 'badImageEncoding',
  failed_dynamo: 'failedDynamo',
  failed_S3: 'failedS3',
  generic_error: 'genericError',
  mediaUploaded: 'mediaUploaded',
  memoryWritten: 'memoryWritten',
  loadedMemories: 'memoryList',
  mediaList: 'mediaList',
  tags: 'tags',
}

export const GenericViewModel = {
  initial: 'initial',
  loading: 'loading',
  error: 'error',
  success: 'success',
}

export const WaitlistViewModel = {
  initial: 'initial',
  loading: 'loading',
  error: 'error',
  success: 'success',
  duplicate_entry: 'duplicateEntry',
}

export const MediaManagerViewModel = {
  initial: 'initial',
  submitting: 'submitting',
  refreshing: 'refreshing',
  successfulUpload: 'successfulUpload',
  loaded: 'loaded',
  error: 'error',
}

export const MemoryManagerViewModel = {
  initial: 'initial',
  submitting: 'submitting',
  refreshing: 'refreshing',
  successfulUpload: 'successfulUpload',
  loaded: 'loaded',
  error: 'error',
}

export function s3linkfrom(uuid) {
  return 'https://s3.us-east-2.amazonaws.com/com.lookatthesepaws.landingmedia/' + uuid
}

export const TallOrWide = {
  tall: 'tall',
  wide: 'wide',
  error: 'error'
}
export function aspect(name){
  //so let's assume that the browser is smart enough to cache the img/URL pair the first time it see's it
  //therefore my double network request concern is moot
  //and the biggest performance penalty we pay right now is possibly loading the same image into
  //   the browser's memory twice(mulitple?) times now.
  //   that's client-side, and I can live with that!
  let theImage = new Image()
  theImage.src = s3linkfrom(name)
  let ratio = theImage.naturalWidth/theImage.naturalHeight
  if (ratio < 1) { return TallOrWide.tall }
  else if (ratio >= 1) { return TallOrWide.wide }
  else { return TallOrWide.error }
}

function apiRequest(body, method) {
  let requestBody
  let endpoint

  if (body === null) { //My Lambda wont even try to decode the 'body' element on model enum cases without associated types.
    body = 'nobody! ha!'
  }

  if (developmentMode) {
    requestBody = JSON.stringify(
      {
        "meta":
          {"requestUUID": "dev", "apiVersion": 1, "requestType": method, "site": "paws"},
        "body": body
      });
    endpoint = 'http://localhost:7000/invoke'
  } else {
    requestBody = JSON.stringify(body);
    endpoint = 'https://publicapi.lookatthesepaws.com'
  }

  return fetch (
    endpoint,
    {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
        'Api-Version': 1,
        'Request-Type': method,
        'Site': 'paws',
      },
      referrerPolicy: 'no-referrer',
      body: requestBody
    }
  ).then(r => r.json())
}

export function loadMemories(list, stateCallback, dataCallback) {
  stateCallback(MemoryManagerViewModel.submitting)
  apiRequest(list, 'loadMemories').then(d => {
    switch (Object.keys(d)[0]) {
      case WaitlistAPIResponseKeys.loadedMemories:
        dataCallback(d[WaitlistAPIResponseKeys.loadedMemories])
        stateCallback(MemoryManagerViewModel.loaded,)
        break

      case WaitlistAPIResponseKeys.failed_S3:
        stateCallback(MemoryManagerViewModel.error)
        break

      default:
        stateCallback(MemoryManagerViewModel.error)
        break
    }
  })
}

export function applyToWaitlist(username, email, petName, petImage, callback) {
  callback("Data!", WaitlistViewModel.loading)
  apiRequest({"username": username, "email": email, "petName": petName, "petImage": petImage}, 'waitlist')
    .then(d => {
    switch (Object.keys(d)[0]) {
      case WaitlistAPIResponseKeys.success:
        callback(
          d[WaitlistAPIResponseKeys.success],
          WaitlistViewModel.success,
        )
        break

      case WaitlistAPIResponseKeys.already_on_waitlist:
        callback(
          d[WaitlistAPIResponseKeys.already_on_waitlist],
          WaitlistViewModel.duplicate_entry,
        )
        break

      case WaitlistAPIResponseKeys.bad_image_encoding:
      case WaitlistAPIResponseKeys.failed_dynamo:
      case WaitlistAPIResponseKeys.failed_S3:
      case WaitlistAPIResponseKeys.generic_error:
        callback(
          "error",
          WaitlistViewModel.error,
        )
        break

      case WaitlistAPIResponseKeys.diagnostic:
        //do nothing for now
        break

      default:
        callback(
          "default error",
          WaitlistViewModel.error,
        )
        break
    }
  })
}
